var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 24,
    viewBox: "0 0 80 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1947 13.3384L33.9573 5.08896L36.3815 2.66477L47.0552 13.3384L36.3815 24L33.9573 21.5758L42.1947 13.3384Z",
    fill: "#F3AA47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8071 13.3384L19.5697 5.08896L21.9938 2.66477L32.6675 13.3384L21.9938 24L19.5697 21.5758L27.8071 13.3384Z",
    fill: "#F3AA47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2493 13.3384L4.99983 5.08896L7.43609 2.66477L18.0977 13.3384L7.43609 24L4.99983 21.5758L13.2493 13.3384Z",
    fill: "#F3AA47"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1395 13.3378L62.9022 5.08829L65.3264 2.6641L76 13.3378L65.3264 23.9993L62.9022 21.5751L71.1395 13.3378Z",
    fill: "#F3AA47"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7524 13.3385L48.515 5.08899L50.9392 2.6648L61.6128 13.3385L50.9392 24L48.515 21.5758L56.7524 13.3385Z",
    fill: "#F3AA47"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIn);
export default __webpack_public_path__ + "static/media/arrow-in.93ce04041caaea7036699f292db5ee93.svg";
export { ForwardRef as ReactComponent };